import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CanvasLoader } from 'site-modules/canvas/components/canvas-loader/canvas-loader';

import './canvas-initialization-overlay.scss';

export function CanvasInitializationOverlay({ className = null, contentClassName = null }) {
  return (
    <div
      className={classnames(
        'canvas-initialization-overlay d-flex flex-column align-items-center justify-content-center',
        className
      )}
      role="status"
      aria-live="polite"
    >
      <div
        className={classnames(
          'canvas-initialization-content d-flex flex-column align-items-center justify-content-center',
          contentClassName
        )}
      >
        <CanvasLoader width={32} className="canvas-loading-overlay" withSparkle />
        <div className="mt-0_75 text-cool-gray-30 fw-bold size-20">Getting things ready…</div>
      </div>
    </div>
  );
}

CanvasInitializationOverlay.propTypes = {
  className: PropTypes.string,
  contentClassName: PropTypes.string,
};
